@if (isLoaded()) {
  <div>
    <div class="modal-title">
      {{ 'home.lobby.modals.search-game.title' | translate }}
    </div>

    <slotcom-navigation-button
      type="close"
      (click)="goBack()">
    </slotcom-navigation-button>

    <div class="search-input">
      <slotcom-search-input
        [label]="'home.lobby.search' | translate"
        [autofocus]="true"
        (valueChange)="applyFilter($event)">
      </slotcom-search-input>
    </div>

    @if (notFound()) {
      <div class="no-result">
        {{ 'home.lobby.modals.search-game.not-found' | translate }}
      </div>
    }
    <div class="game-list">
      @for (game of gamesFiltered; track game) {
        <slotcom-lobby-game
          class="game-cell"
          [game]="game"
          [gameUnlockFlip]="gameUnlockFlip()"
          [tagsList]="tagsList">
        </slotcom-lobby-game>
      }
    </div>
  </div>
}
